import Toastify from 'toastify-js'

const createTeacher = () => {

  // get the teacher form
  let form = document.getElementById("create_teacher_form");

  // check if the form exists in the DOM
  if (form) {

    // create submit event listener

    form.addEventListener("submit", (ev) => {

      // Prevent form submission
      ev.preventDefault();

      // Get form data
      const data = new FormData(form);
      data.append("action", "create_teacher");
      //console.log([...data]);

      // Make the AJAX request
        fetch("/wp-admin/admin-ajax.php", {
            method: "POST", 
            body: data
        })
        .then((response) => response.json())
        .then((response) => {
            
            // Handle the response
            //console.log(response.data);

            Toastify({
              text: response.data.message,
              duration: 2000,
              gravity: "bottom", // `top` or `bottom`
              position: "right", // `left`, `center` or `right`,
              className: "rounded-md shadow", 
              style: {
                background: "#000000",
              },
              callback: () => {
                if(response.data.success){
                  form.reset();
              }
              } 
            }).showToast();

        })
        .catch((error) => {
            // Handle any errors
            console.error(error);
        });

    });

  }
};

export { createTeacher }
